import { z } from 'zod';

const DownPaymentAggregateSchema = z.object({
  downPayment: z.number(),
  count: z.number()
});

const QualifiedVehicleDetailsSchema = z.object({
  apr: z.number(),
  downPayment: z.number(),
  monthlyPayment: z.number(),
  stickerPrice: z.number(),
  term: z.number(),
  vehicleId: z.number()
});

const TradeInDetailsSchema = z.object({
  applyTradeIn: z.boolean(),
  appraisalId: z.number(),
  make: z.string(),
  mobileImage: z.string(),
  model: z.string(),
  status: z
    .string()
    .transform(val => val.toLowerCase())
    .pipe(
      z.union([
        z.literal('active'),
        z.literal('completed'),
        z.literal('deleted'),
        z.literal('expired'),
        z.literal('notset'),
        z.literal('rejected'),
        z.literal('unclaimed')
      ])
    ),
  totalTradeInValue: z.number(),
  trim: z.string(),
  year: z.number()
});

const VehicleAggregateSchema = z.object({
  count: z.number(),
  minimumMonthlyPayment: z.number(),
  name: z
    .string()
    .transform(val => val.toLowerCase())
    .pipe(
      z.union([
        z.literal('convertible'),
        z.literal('coupe'),
        z.literal('hatchback'),
        z.literal('minivan'),
        z.literal('pickup'),
        z.literal('sedan'),
        z.literal('suv'),
        z.literal('wagon')
      ])
    )
});

export const PricingAggregatesSchema = z.object({
  error: z.any().optional(),
  financeInfo: z.object({
    coApplicantEligibility: z.object({
      coBorrowerAllowed: z.boolean(),
      coSignerAllowed: z.boolean(),
      stateAbbreviation: z.string()
    }),
    coApplicantToggleOn: z.boolean(),
    financingType: z.union([z.literal('userFinancing'), z.literal('expired')]),
    hasCoApplicant: z.boolean(),
    maxMonthlyPayment: z.number(),
    minDownPayment: z.number()
  }),
  bodyStyles: z.array(VehicleAggregateSchema),
  downPaymentBuckets: z.array(DownPaymentAggregateSchema),
  minDownVehicle: QualifiedVehicleDetailsSchema,
  minPaymentVehicle: QualifiedVehicleDetailsSchema,
  totalMatchingInventory: z.number(),
  tradeInfo: TradeInDetailsSchema.optional()
});
